import React from 'react';
import { Link } from 'react-router-dom';
import { Combine, Split, Minimize2, Trash2, Image, FileImage, Languages, RefreshCw } from 'lucide-react';
import Card from '../components/common/Card';
import './Home.css';

const Home: React.FC = () => {
    const features = [
        {
            id: 'merge',
            icon: <Combine size={40} />,
            title: '合并 PDF',
            description: '将多个 PDF 文件合并为一个文件',
            path: '/merge',
            color: '#667eea',
        },
        {
            id: 'split',
            icon: <Split size={40} />,
            title: '拆分 PDF',
            description: '按页面范围拆分 PDF 文件',
            path: '/split',
            color: '#764ba2',
        },
        {
            id: 'compress',
            icon: <Minimize2 size={40} />,
            title: '压缩 PDF',
            description: '减小 PDF 文件大小，优化存储',
            path: '/compress',
            color: '#f093fb',
        },
        {
            id: 'delete',
            icon: <Trash2 size={40} />,
            title: '删除页面',
            description: '删除 PDF 中的指定页面',
            path: '/delete',
            color: '#ef4444',
        },
        {
            id: 'pdf-to-image',
            icon: <Image size={40} />,
            title: 'PDF 转图片',
            description: '将 PDF 页面转换为图片格式',
            path: '/pdf-to-image',
            color: '#11998e',
        },
        {
            id: 'image-to-pdf',
            icon: <FileImage size={40} />,
            title: '图片转 PDF',
            description: '将多张图片合并为一个 PDF',
            path: '/image-to-pdf',
            color: '#38bdf8',
        },
        {
            id: 'convert',
            icon: <RefreshCw size={40} />,
            title: '格式转换',
            description: 'PDF 与 Word、Excel 等格式互转',
            path: '/convert',
            color: '#f59e0b', // amber-500
        },
        {
            id: 'translate',
            icon: <Languages size={40} />,
            title: '文档翻译',
            description: '离线翻译 Word、Excel、PDF 文档',
            path: '/translate',
            color: '#14b8a6', // teal-500
        },
    ];

    return (
        <div className="home-page">
            <div className="container">
                {/* <section className="hero">
                    <h1 className="hero-title animate-fade-in">
                        专业的 PDF 编辑工具
                    </h1>
                    <p className="hero-subtitle animate-fade-in">
                        快速、安全、易用的在线 PDF 处理平台
                    </p>
                    <p className="hero-description animate-fade-in">
                        支持合并、拆分、压缩等多种 PDF 操作，无需安装软件，在线即可完成
                    </p>
                </section> */}

                <section className="features">
                    <h2 className="features-title">选择一个功能开始</h2>
                    <div className="features-grid">
                        {features.map((feature, index) => (
                            <Link
                                key={feature.id}
                                to={feature.path}
                                className="feature-link"
                                style={{ animationDelay: `${index * 0.1}s` }}
                            >
                                <Card hover glass>
                                    <div className="feature-card">
                                        <div
                                            className="feature-icon"
                                            style={{ color: feature.color }}
                                        >
                                            {feature.icon}
                                        </div>
                                        <h3 className="feature-title">{feature.title}</h3>
                                        <p className="feature-description">{feature.description}</p>
                                    </div>
                                </Card>
                            </Link>
                        ))}
                    </div>
                </section>


            </div>
        </div>
    );
};

export default Home;
